import React from 'react'
import { NavLink } from 'react-router-dom'
import { FaChartLine, FaUsers, FaRocket, FaCog, FaArrowLeft } from 'react-icons/fa'

const adminItems = [
  { path: '/admin/dashboard', label: 'Analytics', icon: FaChartLine },
  { path: '/admin/customers', label: 'Customers', icon: FaUsers },
  { path: '/admin/campaigns', label: 'Campaigns', icon: FaRocket },
  { path: '/admin/configurations', label: 'Configurations', icon: FaCog },
]

const AdminNav: React.FC = () => {
  return (
    <div className="rounded-tr-2xl rounded-tl-2xl border-b border-[#E3E2E7] px-5 py-3 bg-[#F8F8F8CC] flex items-center gap-2 flex-wrap">
      <NavLink
        to="/dashboard"
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[13px] font-medium text-[#475569] hover:bg-white hover:text-[#0f172a] no-underline transition-colors"
      >
        <FaArrowLeft className="w-3 h-3" /> Exit Admin
      </NavLink>
      <div className="h-5 w-px bg-[#E3E2E7] mx-1" />
      <span className="text-[13px] font-semibold text-[#0f172a] mr-2">Admin</span>
      {adminItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            `flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[13px] font-medium no-underline transition-colors ${
              isActive
                ? 'bg-white text-[#2563EB] shadow-sm'
                : 'text-[#475569] hover:bg-white hover:text-[#0f172a]'
            }`
          }
        >
          <item.icon className="w-3.5 h-3.5" /> {item.label}
        </NavLink>
      ))}
    </div>
  )
}

export default AdminNav
